<div id="form-body">
    <form [formGroup]="loginFormGroup" (ngSubmit)="onSubmit()">
        <div id="form">
            <img src="assets/R1_logo.svg" id="logo" />

            <h2 class="gray-label" id="sign-in-header">Sign In</h2>
            @if (errorMessage) {
                <mat-error id="auth-error" [ngClass]="{ 'failed-twice': secondFailedInvalidCreds }">
                    {{ errorMessage }}
                </mat-error>
            }

            <mat-form-field appearance="outline">
                <mat-label>Email Address</mat-label>
                <input matInput formControlName="username" required class="input" />
                @if (showError('username', 'required')) {
                    <mat-error>Email required</mat-error>
                }
                @if (showError('username', 'email')) {
                    <mat-error>Invalid email</mat-error>
                }
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Password</mat-label>
                <input matInput type="password" formControlName="password" required class="input" />
                @if (showError('password', 'required')) {
                    <mat-error>Password required</mat-error>
                }
            </mat-form-field>

            <r1-password-forget-remember [formGroup]="loginFormGroup" />
        </div>

        <div id="sign-in-btn">
            <button mat-raised-button color="primary">Sign In</button>
        </div>
    </form>
</div>
